import { isValidEmail } from "@utils/isValidEmail";

/** Shared field validators for the auth forms — one source for rules + copy. */

export const MIN_PASSWORD_LENGTH = 6;

export const validateEmail = (email: string): string | undefined => {
  if (!email) return "Email is required";
  if (!isValidEmail(email)) return "Enter a valid email";
  return undefined;
};

export const validatePassword = (password: string): string | undefined => {
  if (!password) return "Password is required";
  if (password.length < MIN_PASSWORD_LENGTH)
    return `At least ${MIN_PASSWORD_LENGTH} characters`;
  return undefined;
};

export const validatePasswordConfirmation = (
  password: string,
  confirmPassword: string
): string | undefined => {
  if (!confirmPassword) return "Please confirm your password";
  if (password && confirmPassword !== password) return "Passwords don't match";
  return undefined;
};
